import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=571d7004&scoped=true&lang=pug&"
import script from "./Confirm.vue?vue&type=script&lang=ts&"
export * from "./Confirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d7004",
  null
  
)

export default component.exports